import { AfterViewInit, Component, OnInit, ViewChild, NO_ERRORS_SCHEMA } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { Location } from '@angular/common';
import { MatTableDataSource } from '@angular/material/table';
import { environment } from '../../../../environments/environment';
import { ExportDataService } from '../../../shared/services/export-data.service';
import { ToastrService } from 'ngx-toastr';
import { MaintenanceService } from '../../services/maintenanceService';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DailogModalComponent } from '../../../shared/elements/dailog-modal/dailog-modal.component';
import { SharedAuthService } from '../../../shared/shared.auth.service';
import { take } from 'rxjs/operators';
import { MatTabGroup, MatTab } from '@angular/material/tabs';
import { MatFormField } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from '../../../shared/elements/loader/loader.component';
import { MaintenanceTableV4Component } from '../maintenance-table-v4/maintenance-table-v4.component';
import { OrgMaintenanceV4Component } from '../org-maintenance-v4/org-maintenance-v4.component';
import { DecomLobComponent } from '../decom-lob/decom-lob.component';
import { AppModalComponent } from '../../../shared/elements/app-modal/app-modal.component';
import { LobAddPopupComponent } from './lob-add-popup/lob-add-popup.component';
import { DeleteLobComponent } from './delete-lob/delete-lob.component';
import { LobBulkEditComponent } from './lob-bulk-edit/lob-bulk-edit.component';
import { AddRemovePopupComponent } from '../add-remove-popup/add-remove-popup.component';
@Component({
    selector: 'app-lob-maintenance',
    templateUrl: './lob-maintenance.component.html',
    styleUrls: ['./lob-maintenance.component.scss'],
    imports: [MatTabGroup, MatTab, RouterLink, MatFormField, MatInput, FormsModule, LoaderComponent, MaintenanceTableV4Component, OrgMaintenanceV4Component, DecomLobComponent, AppModalComponent, LobAddPopupComponent, DeleteLobComponent, LobBulkEditComponent, AddRemovePopupComponent],
    schemas: [NO_ERRORS_SCHEMA],
})
export class LobMaintenanceComponent implements OnInit,AfterViewInit {

  expandAll: string = 'false';
  exportToExcel: number = 1;
  allRowsExpanded = false;
  postData;
  isUserAdmin: string = "false";
  selectedCapability;
  dataSourceDetails: MatTableDataSource<any>;
  olddatasource: any;
  rawDataSet: any;
  clearFormFields:boolean = false;
  DecomLobViewAccess: boolean = false;
  DecomLobEditAccess: boolean = false;
  TABLE_COLUMNS: any = [
    {
      key: 'MasterSegment',
      labelKey: "SegID",
      label: 'Segment',
      width: '10.5% !important',
      addNew: false,
      filter: true,
      search: '',
      searchValue: '',
      edit: false,
      validations: [{ 'required': true }],
      padding: '5px 5px 5px 24px !important'
    },
    {
      key: 'LobID',
      width: '7% !important',
      label: 'LOB ID',
      // filter: true,
      search: '',
      searchValue: '',
      padding: '5px 5px 5px 0 !important'
    },
    {
      key: 'CIOLOB',
      labelKey: "CIOLOB",
      width: '13% !important',
      addNew: true,
      label: 'LOB',
      edit: true,
      filter: true,
      search: '',
      searchValue: '',
      validations: [{ 'required': true }],
      padding: '5px 15px 5px 0px !important'
    },
    {
      key: 'LOB_description',
      label: 'LOB Description',
      width: '27% !important',
      padding: '5px 15px 5px 0px !important'
    },
    {
      key: 'subLobCount',
      label: 'Sub LOB Count',
      width: '10% !important',
      align: 'center !important'
    },
    {
      key: 'Actions',
      label: 'Actions',
      width: '10% !important',
      align: 'center !important',
      padding: '5px 5px 5px 0px !important'
    }
  ];

  expanded_columns: any = [

    {
      key: 'SubLobID',
      labelKey: 'SubLobID',
      label: 'Sub LOB ID',
      width: '12% !important',
      edit: true,
      addNew: true,
      // filter: true,
      search: '',
      searchValue: '',
    },
    {
      key: 'SubLineofBusiness',
      labelKey: "SubLOB",
      label: 'Sub LOB',
      width: '26.3% !important',
      addNew: true,
      edit: true,
      filter: true,
      search: '',
      searchValue: '',
      validations: [{ 'required': true }],
      padding: '5px 15px 5px 0px !important'
    },
    {
      key: 'Sub_LOB_description',
      label: 'Sub LOB Description',
      width: '20% !important',
      padding: '5px 15px 5px 0px !important'
    },
    {
      key: 'ChiefArchitect',
      labelKey: 'ChiefArchitect',
      label: 'Chief Architect',
      width: '16% !important',
      edit: true,
      search: '',
      searchValue: '',
      filter: true,
      // validations: [{ 'required': true }]
    },
    {
      key: 'ArchitectDelegate',
      labelKey: 'ArchitectDelegate',
      label: 'Architect Delegate',
      width: '13% !important',
      edit: true,
      search: '',
      searchValue: '',
      filter: true,
    },
    {
      key: 'Actions',
      label: '',
      width: '10% !important',
      padding: "5px 5px 5px 5px"
    }
  ];

  editModelView: boolean = environment.isAdminRole;
  FILTERS: any = [];

  DATA_SCHEMA = {
    "MasterSegment": "select",
    "CIOLOB": "select",
    "SubLineofBusiness": "select",
    "ChiefArchitect": "autocomplete",
    "ArchitectDelegate": "autocomplete",
    "isEdit": 'isEdit'
  }
  FILTER_OPTIONS: any = {}
  OriginalFiltersList: any = {}
  TABLE_CONFIG: any = {
    expandable: true,
    pageSize: 10,
    pageIndex: 0,
    totalItems: 10,
    selection: false,
    edit: false,
    serverSidePagination: false,
    dependentFilters: {
      MasterSegment: ['CIOLOB', 'SubLineofBusiness'],
    }
  };

  sortConfig = {
    active: 'Full_Name',
    direction: 'asc',
  }

  decomAccessLoaded = false;
  showLoader: boolean = true;
  partialLoader: boolean = false;
  searchField: any;
  deleteRecords: any;
  userAccessData: any;
  selectedOption: any = 'lob';
  @ViewChild('modalAddLob', { static: false }) modalAddLob;
  @ViewChild('modalEditSubLob', { static: false }) modalEditSubLob;
  @ViewChild('modalEditLob', { static: false }) modalEditLob;
  EditColumnDataSubLob: any;
  EditColumnDataLob: any;
  isNewClicked: boolean = false;
  isSubLobEditClicked: boolean = false;
  isLobEditClicked: boolean = false;
  @ViewChild('deleteModel', { static: false }) deleteModel;
  isDeleteClicked: boolean = false;
  deleteSelectedSubLob: any;
  lobList: any;
  segmentList: { SegID: any; MasterSegment: any; }[];
  sublobList: void;
  @ViewChild('bulkModel', { static: false }) bulkModel;
  isBulkClicked: boolean = false;
  dataSourceFull: any;
  dataPersistObj: MatTableDataSource<any>;
  lobLoader: boolean = false;
  accessDataSet = false;
  lobDataSet = false;
  sort: any;
  @ViewChild('addRemoveCAModel', { static: false }) addRemoveCAModel;
  isAddRemoveClicked: boolean;
  paramSubLobId:any;
  isInitialSearch: boolean = false;
   tabs: Array<any> = [ { label: 'LOB', value: 'lob' }, 
    { label: 'Organization', value: 'org' }, 
    { label: 'Decom LOB', value: 'decom_lob' },];
   selectedTab: string = 'lob';
   selectedIndex: number = 0;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    public maintenanceService: MaintenanceService,
    public exportService: ExportDataService,
    private toastrService: ToastrService,
    public dialog: MatDialog,private sharedAuthService : SharedAuthService) { }

  ngAfterViewInit(): void {
    this.route.queryParams.subscribe(params => {
      if(params && params['subLOBId']){
        this.paramSubLobId = params['subLOBId'];
        this.isInitialSearch = true;
        this.searchField = params['subLOBId'];
      }
    });
  }

  ngOnInit() {
    const queryTab = this.route.snapshot.queryParamMap.get('selectedTab');
    if (queryTab) {
      const tabIndex = this.tabs.findIndex(tab => tab.value === queryTab);
      this.selectedIndex = tabIndex >= 0 ? tabIndex : 0;
      this.selectedOption = queryTab;
    } else {
      this.selectedIndex = 0;
      this.selectedOption = this.tabs[this.selectedIndex]?.value || 'lob';
    }
    
    this.deleteRecords = [];
    if (!sessionStorage.getItem('techaccessData')) {
      this.sharedAuthService.userAccessDataSource.pipe(take(1)).subscribe(accessData => {
        this.handleAppicationload();
        this.getDecomLobAccess()
      });
    } else {
        this.handleAppicationload();
        this.getDecomLobAccess()
    }
  }
  getDecomLobAccess() {
    let decomLOBAccess: any = {};
    decomLOBAccess = this.sharedAuthService.getDecomLobAccessDetails();
    this.DecomLobViewAccess = decomLOBAccess.isDecomLobViewAccess;
    this.DecomLobEditAccess = decomLOBAccess.isDecomLobEditAccess;
    this.decomAccessLoaded = true;
  }
  collapseAllFunc(data) {
    if (data == true) {
      this.allRowsExpanded = true;
    }
    else {
      this.allRowsExpanded = false;
    }
  }
  expandAllFunc() {
    if (this.expandAll == 'true' || this.allRowsExpanded == true) {
      if (this.expandAll == 'false')
        this.expandAll = 'false1';
      else
        this.expandAll = 'false';
      this.allRowsExpanded = false;
    }
    else {
      this.expandAll = 'true';
      this.allRowsExpanded = true;
    }
  }

   handleAppicationload = async () => {
    const postparams: any = {};
    this.postData = postparams;
    this.selectedCapability = this.postData[this.postData['level']];
    this.showLoader = true;
    const isAdminRole = this.sharedAuthService.checkAdminSGAccess();
    let data = null;
    try {
      data = this.sharedAuthService.getTechAccessData();
    } catch (e) {
      data = null;
    }
    const user_role = data ? data['Role'] : '';
    const isAdmin = (isAdminRole && (user_role.toLowerCase() == 'admin')).toString();
    if (isAdmin == 'true') {
      this.TABLE_CONFIG['edit'] = true;
      this.TABLE_CONFIG['selection'] = false;
    }
    this.accessDataSet = true;
    this.showLoader = this.lobDataSet == true ? false : true;
    this.getLobMappingDetails();
  }

  getFiltersList() {
    return new Promise(() => {
      
    })

  }
  searchClear() {
    this.searchField = "";
  }

    getLobMappingDetails() {
    const filter = this.getFilters();
    this.resetSearchState();
    
    this.maintenanceService.GetLobArchitectMappingList(filter).subscribe(
      (results: any) => this.handleLobMappingSuccess(results, filter),
      (error) => this.handleLobMappingError(error)
    );
  }
  
  private resetSearchState(): void {
    this.deleteRecords = '';
    this.showLoader = true;
    this.searchField = '';
    this.TABLE_CONFIG['TABLE_CLASS'] = 'lob-maintenance-tble-container';
    this.TABLE_CONFIG['FILTER_OPTIONS'] = JSON.parse(JSON.stringify(this.FILTER_OPTIONS));
  }
  
  private handleLobMappingSuccess(results: any, filter: any): void {
    if (!results) {
      return;
    }
  
    results.sort((a, b) => (a.CIOLOB < b.CIOLOB ? -1 : 1));
    const dataset = results.map((ele, index) => this.processLobElement(ele, index));
    
    this.updateDataSource(dataset);
    this.TABLE_CONFIG.totalItems = results.data?.length ? results.data[0].ROW_COUNT : 0;
    this.finalizeLoading();
    
    if (filter.filters.length === 0) {
      this.dataSourceFull = results;
    }
    
    if (this.isInitialSearch) {
      this.performInitialSearch();
    }
  }
  
  private processLobElement(ele: any, index: number): any {
    let count = 0;
    ele.sublob.sort((a, b) => (a.SubLineofBusiness < b.SubLineofBusiness ? -1 : 1));
    
    ele.sublob.forEach(sublobItem => {
      count += 1;
      this.processSublobItem(sublobItem, ele);
    });
    
    ele['subLobCount'] = count;
    ele['id'] = index;
    
    return {
      ...ele,
      childDataSource: new MatTableDataSource(ele.sublob)
    };
  }
  
  private processSublobItem(item: any, parentElement: any): void {
    this.sortArchitectRoles(item);
    this.setArchitectLabels(item);
    this.setParentReferences(item, parentElement);
  }
  
  private sortArchitectRoles(item: any): void {
    item['ArchitectDelegate'].sort((a, b) => (a.sn < b.sn ? -1 : 1));
    item['ChiefArchitect'].sort((a, b) => (a.sn < b.sn ? -1 : 1));
  }
  
  private setArchitectLabels(item: any): void {
    item['ArchitectDelegateLabel'] = item['ArchitectDelegate'] 
      ? item['ArchitectDelegate'].map(element => element.displayName) 
      : '';
    
    item['ChiefArchitectLabel'] = item['ChiefArchitect'] 
      ? item['ChiefArchitect'].map(element => element.displayName) 
      : '';
  }
  
  private setParentReferences(item: any, parentElement: any): void {
    item['LobID'] = parentElement.LobID;
    item['CIOLOB'] = parentElement.CIOLOB;
    item['MasterSegment'] = parentElement.MasterSegment;
  }
  
  private updateDataSource(dataset: any[]): void {
    this.olddatasource = dataset;
    this.dataSourceDetails = new MatTableDataSource(dataset);
    this.dataPersistObj = this.dataSourceDetails;
  }
  
  private finalizeLoading(): void {
    this.lobDataSet = true;
    this.showLoader = this.accessDataSet === true ? false : true;
  }
  
  private performInitialSearch(): void {
    const obj = {
      target: {
        value: this.paramSubLobId
      }
    };
    this.searchDataSet(obj);
  }
  
  private handleLobMappingError(error: any): void {
    console.error(error);
    this.lobDataSet = true;
    this.showLoader = this.accessDataSet === true ? false : true;
    this.dataSourceDetails = new MatTableDataSource([]);
    this.TABLE_CONFIG.totalItems = 0;
  }

  getFilters() {
    const params: any = {};
    if (this.FILTERS) {
      params['filters'] = this.prepareFilters();
    }

    return params;
  }

  prepareFilters() {
    const filters = [];
    if (this.FILTERS && this.FILTERS.length) {
      this.FILTERS.forEach(element => {
        if (element.key && element.searchValue.length)
          filters.push({ name: element.key, values: element.searchValue });
      });
    }
    return filters;
  }


  /**
  * 
  * @param event 
  */
  tablePaginationEvent(event) {
    if (event) {
      if (event.sort) {
        this.sort = event.sort;
      }
      this.TABLE_CONFIG['pageSize'] = event.pageSize;
      this.TABLE_CONFIG['pageIndex'] = event.pageIndex;
      this.getLobMappingDetails();
    }
  }

  searchEvent(event) {
    if (event) {
      if (event.type == 'apply') {
        this.FILTERS.push(event.column);
      } else {
        this.FILTERS = this.FILTERS.filter(((ele) => ele.key != event.column.key));
      }
      this.TABLE_CONFIG['pageSize'] = 10;
      this.TABLE_CONFIG['pageIndex'] = 0;
      this.getLobMappingDetails();
    }
  }

  AddNewEntry() {
    this.showAddPopup();
  }

  exportToCsv() {
    this.exportToExcel = this.exportToExcel + 1;
  }


  preparePostDate(record) {

    const segment = this.OriginalFiltersList['MasterSegment'].find((ele: any) => ele.value == record['SegID']['value']);
    const lob = this.OriginalFiltersList['CIOLOB'].find((ele: any) => ele.value == record['LobID']['value']);
    const sublob = this.OriginalFiltersList['SubLineofBusiness'].find((ele: any) => ele.value == record['SubLobID']['value']);

    const payload = {
      MasterSegment: segment && segment['value'],
      SegID: segment && segment['key'],
      CIOLOB: lob && lob['value'].trim(),
      LobID: lob && lob['key'],
      SubLineofBusiness: sublob && sublob['value'].trim(),
      SubLobID: sublob && sublob['key'],
      Data: []
    }

    if (record['ArchitectDelegate']) {
      const roleMa: any = {
        name: "ArchitectDelegate",
        values: record['ArchitectDelegate'].map((ele) => ele.msid),
        displayname: record['ArchitectDelegate'].map((ele) => ele.mail)
      }
      payload['Data'].push(roleMa);
    }

    if (record['ChiefArchitect']) {
      const roleMa: any = {
        name: "ChiefArchitect",
        values: record['ChiefArchitect'].map(ele => ele.msid),
        displayname: record['ArchitectDelegate'].map((ele) => ele.mail)
      }
      payload['Data'].push(roleMa);
    }

    return payload;
  }

  isObject(value) {
    return value && typeof value === 'object' && !Array.isArray(value);
  }

  saveEvent(record) {
    this.partialLoader = true;
    this.searchField = '';
    if (record['isNew']) {
      const postBody = this.preparePostDate(record);
      this.maintenanceService.SaveLobMapping(postBody).subscribe((result) => {
        if (result) {
          this.partialLoader = false;
          this.toastrService.success('Record Saved Successfully', '', { timeOut: 2000, positionClass: 'toast-top-center' });
          this.getLobMappingDetails();
        }
      }, (error) => {
        console.error(error);
        this.partialLoader = false;
        this.toastrService.error('Something went wrong, Please try again later.', '', { timeOut: 2000, positionClass: 'toast-top-center' });
        this.getLobMappingDetails();
      });
    } else {
      let originalDataSet = this.rawDataSet.find((ele) => ele.LobID == record['LobID'] && ele.SegID == record['SegID'] && ele.SubLobID == record['SubLobID']);
      if (!originalDataSet) {
        originalDataSet = this.rawDataSet.find((ele) => ele.LobID == record['LobID'] && ele.SegID == record['SegID']);
      }
      let sublob: any = '';
      if (this.isObject(record['SubLobID']) && record['addsublob']) {
        sublob = JSON.parse(JSON.stringify(record['SubLobID']));
        record['SubLobID'] = record['SubLobID']['key'];
      }

      const body: any = {
        SegID: record['SegID'],
        LobID: record['LobID'],
        SubLobID: record['SubLobID'],
        'addSubLoB': {
          status: record['addsublob'] ? record['addsublob'] : false,
          data: sublob
        },
        'remove': this.prepareRemoveDataset(record, originalDataSet),
        'add': this.prepareAddDataset(record, originalDataSet),
        'changes': {},
      }
      let rename = false;
      if (originalDataSet["CIOLOB"] && originalDataSet["CIOLOB"].toLowerCase() != record['CIOLOB'].toLowerCase()) {
        if (!body['changes']) {
          body['changes'] = {}
        }
        body['changes']['CIOLOB'] = record['CIOLOB'].trim();
        rename = true;
      }

      if (originalDataSet["SubLineofBusiness"] && originalDataSet["SubLineofBusiness"].toLowerCase() != record['SubLineofBusiness'].toLowerCase()) {
        if (!body['changes']) {
          body['changes'] = {}
        }
        body['changes']['SubLineofBusiness'] = record['SubLineofBusiness'].trim();
        rename = true;
      }

      this.maintenanceService.UpdateLobMapping(body).subscribe(async (result) => {
        if (result) {
          this.toastrService.success('Record Saved Successfully', '', { timeOut: 2000, positionClass: 'toast-top-center' });
          if (rename) {
            await Promise.all([this.getFiltersList()]);
          }
          this.partialLoader = false;
          this.getLobMappingDetails();
        }
      }, (error) => {
        console.error(error);
        this.partialLoader = false;
        this.toastrService.error('Something went wrong, Please try again later.', '', { timeOut: 2000, positionClass: 'toast-top-center' });
        this.getLobMappingDetails();
      });
    }
  }

  async CreateEvent(data) {
    const savetyepe = data.type
    let savePayload: any = {};
    let segment;
    let lob;
    switch (savetyepe) {
      case 'Add_CIOLOB':
        segment = this.OriginalFiltersList['MasterSegment'].find((ele: any) => ele.value == data.element['MasterSegment']);
        savePayload = {
          LoBName: data.data.name && data.data.name.trim(),
          SegmentId: segment['key'],
          SegmentName: segment['value'],
        }
        this.partialLoader = true;
        this.maintenanceService.CreateLoB(savePayload).subscribe(async (result) => {
          if (result) {
            this.toastrService.success('LoB Created Successfully', '', { timeOut: 2000, positionClass: 'toast-top-center' });
            await Promise.all([this.getFiltersList()]);
            this.partialLoader = false;
            this.getLobMappingDetails();
          }
        }, (error) => {
          console.error(error);
          this.toastrService.error('Something went wrong, Please try again later.', '', { timeOut: 2000, positionClass: 'toast-top-center' });
        })
        break;
      case 'Add_SubLineofBusiness':
        segment = this.OriginalFiltersList['MasterSegment'].find((ele: any) => ele.value == data.element['MasterSegment']);
        lob = this.OriginalFiltersList['CIOLOB'].find((ele: any) => ele.value == data.element['CIOLOB']);
        savePayload = {
          SubLoBName: data.data.name && data.data.name.trim(),
          LobId: lob ? lob['key'] : '',
          LoBName: lob ? lob['value'] : '',
          SegmentId: segment ? segment['key'] : '',
          SegmentName: segment ? segment['value'] : '',
        }
        this.partialLoader = true;
        this.maintenanceService.CreateSubLoB(savePayload).subscribe(async (result) => {
          if (result) {
            this.toastrService.success('SUB LoB Created Successfully', '', { timeOut: 2000, positionClass: 'toast-top-center' });
            await Promise.all([this.getFiltersList()]);
            this.partialLoader = false;
            this.getLobMappingDetails();
          }
        }, (error) => {
          console.error(error);
          this.toastrService.error('Something went wrong, Please try again later.', '', { timeOut: 2000, positionClass: 'toast-top-center' });
        })
        break;
    }
  }

  prepareAddDataset(record, originalDataSet) {
    const Data: any[] = [];
    if (record['ArchitectDelegate']) {
      const diff = this.findDifferenceBetweenroles(originalDataSet, record, 'ArchitectDelegate', 'ArchitectDelegate')
      if (diff) {
        Data.push(diff);
      }
    }

    if (record['ChiefArchitect']) {
      const roleArc = this.findDifferenceBetweenroles(originalDataSet, record, 'ChiefArchitect', 'ChiefArchitect')
      if (roleArc) {
        Data.push(roleArc);
      }
    }

    return Data;
  }


  prepareRemoveDataset(record, originalDataSet) {
    const Data: any[] = [];
    if (record['ArchitectDelegate']) {
      const diff = this.findDifferenceBetweenroles(record, originalDataSet, 'ArchitectDelegate', 'ArchitectDelegate')
      if (diff) {
        Data.push(diff);
      }
    }

    if (record['ChiefArchitect']) {
      const diff = this.findDifferenceBetweenroles(record, originalDataSet, 'ChiefArchitect', 'ChiefArchitect')
      if (diff) {
        Data.push(diff);
      }
    }

    return Data;
  }

  findDifferenceBetweenroles(record, originalDataSet, matchingrole, postrole) {
    const orig = originalDataSet[matchingrole] ? originalDataSet[matchingrole] : [];
    const updated = record[matchingrole] ? record[matchingrole] : [];
    const diff = orig.filter(d => {
      const v = updated.find((u) => u['msid'] == d['msid'])
      if (!v) {
        return true;
      } else {
        return false;
      }
    });
    if (diff && diff.length) {
      const obj: any = {
        name: postrole,
        values: diff.map((ele) => ele.msid),
        mail: diff.map((ele) => ele.mail),
        employeeID: diff.map((ele) => ele.employeeID),
        givenName: diff.map((ele) => ele.givenName),
        sn: diff.map((ele) => ele.sn),
        middleName: diff.map((ele) => ele.middleName),
        displayName: diff.map((ele) => ele.displayName)
      }
      return obj;
    }
    return '';
  }

  navigateHomePage() {
    this.router.navigate([{ outlets: { primary: 'landing-page' } }]);
  }

  searchDataSet(event) {
    this.isInitialSearch = false;
    this.olddatasource.forEach(element => {
      element.childDataSource = new MatTableDataSource(element['sublob']);

      element.childDataSource.filterPredicate = function (data, filter: string): boolean {
        let foundInArchitectDelegate = false;
        let foundInChiefArchitect = false;
        data.ArchitectDelegateLabel.forEach(element => {
          if (element.toLowerCase().includes(filter.toLowerCase())) {
            foundInArchitectDelegate = true;
          }
        });
        data.ChiefArchitectLabel.forEach(element => {
          if (element.toLowerCase().includes(filter.toLowerCase())) {
            foundInChiefArchitect = true;
          }
        });
        return data.SubLineofBusiness.toLowerCase().includes(filter.toLowerCase()) || data.SubLobID.toLowerCase().includes(filter.toLowerCase())
          || foundInArchitectDelegate || foundInChiefArchitect;
      };
    });

    let filterValue = event ? (event.target as HTMLInputElement).value : '';
    filterValue = filterValue.trim().toLowerCase();

    this.dataSourceDetails = new MatTableDataSource(this.olddatasource);
    this.dataSourceDetails.filterPredicate = function (data, filter: string): boolean {
      return data.CIOLOB.toLowerCase().includes(filter.toLowerCase()) || data.MasterSegment.toLowerCase().includes(filter.toLowerCase())
        || data.LobID.toLowerCase().includes(filter.toLowerCase());
    };
    this.dataSourceDetails.filter = filterValue;
    const lobFilteredData = this.dataSourceDetails.filteredData;
    this.dataSourceDetails = new MatTableDataSource(this.olddatasource);
    this.dataSourceDetails.filterPredicate = function (data, filter: string): boolean {
      return data.CIOLOB.toLowerCase().includes(filter.toLowerCase()) || data.MasterSegment.toLowerCase().includes(filter.toLowerCase())
        || data.LobID.toLowerCase().includes(filter.toLowerCase());
    };

    const subLobFilteredData = [];

    if (lobFilteredData.length) {
      this.dataSourceDetails.data.forEach((element: any) => {
        const inLob = lobFilteredData.find(function (el) { return el.id == element.id }) !== undefined;
        if (inLob) {
          subLobFilteredData.push(element);
        }
        else {
          element.childDataSource.filter = filterValue;
          if (element.childDataSource.filteredData.length) {
            subLobFilteredData.push(element);
          }
        }
      });
    }
    else {
      this.dataSourceDetails.data.forEach(element => {
        element.childDataSource.filter = filterValue;
        if (element.childDataSource.filteredData.length) {
          subLobFilteredData.push(element);
        }
      });
    }

    if (subLobFilteredData.length) {
      this.dataSourceDetails = new MatTableDataSource(subLobFilteredData);
    }
    else {
      this.dataSourceDetails.filter = filterValue;
    }

    setTimeout(() => {
      if (filterValue == '') {
        this.expandAll = 'false';
        this.allRowsExpanded = false;
      } else {
        this.expandAll = 'true';
        this.allRowsExpanded = true;
      }
    }, 500)
  }

  checkBoxEvent(event) {
    let deleteRec = [];
    if (event.data && event.data.length) {
      deleteRec = event.data.map((ele) => {
        const obj: any = {
          LobID: ele['LobID'],
          SubLobID: ele['SubLobID'],
        }
        return obj;
      })
    }
    this.deleteRecords = deleteRec;
  }

  DeleteRecords() {

    if (this.deleteRecords && this.deleteRecords.length) {
      this.searchField = '';
      const deleteids = this.deleteRecords;
      const deleteParams: any = {};
      deleteParams['data'] = deleteids;
      this.partialLoader = true;
      this.maintenanceService.DeleteMappings(deleteParams).subscribe((data) => {
        if (data) {
          this.partialLoader = false;
          this.toastrService.success("Records Deleted successfully.", '', { timeOut: 2000, positionClass: 'toast-top-center' });
          this.getLobMappingDetails();
        }
      }, (error) => {
        console.error(error);
        this.partialLoader = false;
        this.toastrService.error("Something went wrong, Please try again later.", '', { timeOut: 2000, positionClass: 'toast-top-center' })
      })
    }
  }

  selectionTypeChange(event) {
    console.log('selected value in lob main', event);
    this.selectedIndex = event.index;
    this.selectedOption = this.tabs[event.index].value;
    const url = this.router.createUrlTree([], {
      relativeTo: this.route,
      queryParams: { selectedTab: this.selectedOption },
      queryParamsHandling: 'merge'
    });
    this.location.replaceState(url.toString());
  }

  showInfo() {
    if (this.selectedOption === 'lob') {
      window.open(environment.docUrl + 'user-guide/lob-maintenance/');
    } else if (this.selectedOption === 'org') {
      window.open(environment.docUrl + 'user-guide/organization-maintenance/');
    } else if (this.selectedOption === 'decom_lob') {
      window.open(environment.docUrl + 'user-guide/decom-lob-maintenance/');
    }
  }
  showAddPopup() {
    this.isNewClicked = true;
    this.modalAddLob.show();
  }
  showEditPopup() {
    this.modalEditSubLob.show();
  }
  subLobEditClicked(element) {
    this.EditColumnDataSubLob = element;
    this.isSubLobEditClicked = true;
    this.showEditPopup();
  }

  showLobEditPopup() {
    this.isLobEditClicked = true;
    this.modalEditLob.show();
  }
  LobEditClicked(lobData) {
    this.EditColumnDataLob = lobData;
    this.showLobEditPopup();
  }
  loadDeletePopup(row) {
    this.deleteSelectedSubLob = row;
    this.segmentList = this.dataSourceDetails.data.map(x => ({ SegID: x.SegID, MasterSegment: x.MasterSegment }));
    this.segmentList = [...new Set(this.segmentList)]
    this.lobList = this.dataSourceDetails.data.map(x => ({ LobID: x.LobID, CIOLOB: x.CIOLOB, sublob: x.sublob }));
    this.showDeletePopup();
  }

  showDeletePopup() {
    this.isDeleteClicked = true;
    if (this.deleteSelectedSubLob.appCount === 0) {
      const payload = {
        "source": {
          "SubLobID": this.deleteSelectedSubLob.SubLobID,
          "lob_id": this.deleteSelectedSubLob.LobID,
          "sub_lob": this.deleteSelectedSubLob.SubLineofBusiness,
          "lob": this.deleteSelectedSubLob.CIOLOB
        }
      };
      const subTitliMsg = 'No associated Apps. Delete Sub LOB - ' + this.deleteSelectedSubLob.SubLineofBusiness;
      subTitliMsg.replace('\n/g', '<br/>');
      const dialogConfig = new MatDialogConfig();
      dialogConfig.width = '400px';
      dialogConfig.hasBackdrop = true;
      dialogConfig.minHeight = '200px';
      dialogConfig.height = 'auto';
      dialogConfig.autoFocus = false;
      dialogConfig.data = {
        title: 'Delete Confirmation!',
        subTitle: subTitliMsg,
        buttonName: 'Continue'
      };

      const dialogRef = this.dialog.open(DailogModalComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(result => {

        if (result.data != 'cancel') {
          this.lobLoader = true;
          this.maintenanceService.deleteSubLOB(payload).subscribe(res => {
            if (res) {
              this.handleAppicationload();
              this.lobLoader = false;
              this.toastrService.success('Sub LOB deleted Successfully!', '', {
                timeOut: 10000,
                positionClass: 'toast-top-center'
              });
            }
          })
        }
      },
        (error) => {
          console.error(error);
          this.toastrService.error(error.error.message, '', {
            timeOut: 10000,
            positionClass: 'toast-top-center'
          });
        });
    } else {
      this.deleteModel.show();
    }
  }

  hideDeletePopup() {
    this.deleteModel.hide();
    this.isDeleteClicked = false;
    this.handleAppicationload()
  }
  showBulkPopup() {
    this.isBulkClicked = true;
    this.bulkModel.show();
  }
  addLobServiceCall(payload, msg) {
    this.maintenanceService.addLOB(payload).subscribe(res => {
      if (res.message === 'Added successfully') {
        this.toastrService.success(msg + ' Added Successfully!', '', {
          timeOut: 10000,
          positionClass: 'toast-top-center'
        });
        this.lobLoader = false;
        this.modalAddLob.hide();
        this.getLobMappingDetails();
      }
    },
      (error) => {
        console.error(error);
        this.toastrService.error(error.error.message, '', {
          timeOut: 10000,
          positionClass: 'toast-top-center'
        });
        this.lobLoader = false;
        this.modalAddLob.hide();
      }
    );

  }

  applyAddLob(addLobData) {
    this.lobLoader = true;
    const payload = {
      "SegId": addLobData.SegId,
      "master_segment": addLobData.master_segment_name,
      "chiefArchitect": addLobData.ChiefArchitect,
      "architectDelegate": addLobData.ArchitectDelegate,
    }
    payload['chiefArchitect'] = this.addLeadEAToPayload(payload.chiefArchitect);
    payload['architectDelegate'] = this.addLeadEAToPayload(payload.architectDelegate)

    if (!addLobData.lobNameEntered) {
      const payloadNameCheck = {
        "sub_lob": addLobData.sub_lob,
        'lob_id': addLobData.lob_id
      }
      this.maintenanceService.checkLOB(payloadNameCheck).subscribe(res => {
        if (res) {
          this.toastrService.error('Sub LOB Name already exists', '', {
            timeOut: 10000,
            positionClass: 'toast-top-center'
          });
          this.lobLoader = false;
        }
        else {
          payload["Sub_LOB_description"] = addLobData.Sub_LOB_description ? addLobData.Sub_LOB_description : null;
          payload["lob"] = addLobData.cio_lob_name;
          payload["lob_id"] = addLobData.lob_id;
          payload["sublob"] = addLobData.sub_lob;
          const msg = 'Sub LOB';
          this.addLobServiceCall(payload, msg);
        }
      })
    }
    else {
      const payloadNameCheck = {
        "cio_lob": addLobData.lobNameEntered
      }
      this.maintenanceService.checkLOB(payloadNameCheck).subscribe(res => {
        if (!res) {
          payload["lob"] = addLobData.lobNameEntered;
          payload["LOB_description"] = addLobData.LOB_description ? addLobData.LOB_description : null;
          payload["Sub_LOB_description"] = addLobData.Sub_LOB_description ? addLobData.Sub_LOB_description : null;
          if (addLobData.sub_lob !== addLobData.lobNameEntered) {
            payload["sublob"] = addLobData.sub_lob;
          }
          const msg = 'LOB'
          this.addLobServiceCall(payload, msg);
        }
        else {
          this.toastrService.error('LOB Name already exists', '', {
            timeOut: 10000,
            positionClass: 'toast-top-center'
          });
          this.lobLoader = false;
        }
      })

    }
  }

  //map the role & leadEA value to the payload
  addRoleToPayload(payload, role) {
    return payload.map(ele => ({
      ...ele,
      role,
      lead_EA: ele['leadEA']
    }));
  }

  addLeadEAToPayload(payload) {
    if(payload.length >0){
      return payload.map(ele => ({
        ...ele,
        lead_EA: ele['leadEA'] ? ele['leadEA'] : 'No'
      }));
    }else{
      return [];
    }
    
  }

  applyEditSubLob(EditSubLobData) {
    this.lobLoader = true;
    const payload = {};
    if (EditSubLobData.Sub_LOB_description.isChanged) {
      payload['Sub_LOB_description'] = EditSubLobData.Sub_LOB_description.value ? EditSubLobData.Sub_LOB_description.value : null;
    }
    payload['add'] = this.addRoleToPayload(EditSubLobData.addAD, "Architect Delegate").concat(this.addRoleToPayload(EditSubLobData.addCA, "Chief Architect"));
    payload['remove'] = this.addRoleToPayload(EditSubLobData.removeAD, "Architect Delegate").concat(this.addRoleToPayload(EditSubLobData.removeCA, "Chief Architect"));
    payload['LeadStatusUpdate'] = this.addRoleToPayload(EditSubLobData.leadsToUpdateAD, "Architect Delegate").concat(this.addRoleToPayload(EditSubLobData.leadsToUpdateCA, "Chief Architect"));
    if (EditSubLobData.SubLineofBusiness.isChanged || EditSubLobData.Sub_LOB_description.isChanged ||
      EditSubLobData.add || EditSubLobData.remove) {
      payload['lob_id'] = EditSubLobData.lob_id;
      payload['SubLobID'] = EditSubLobData.SubLobID;
      if (EditSubLobData.SubLineofBusiness.isChanged) {
        payload['sublob'] = EditSubLobData.SubLineofBusiness.value;
        const payloadNameCheck = {
          "sub_lob": EditSubLobData.SubLineofBusiness.value,
          'lob_id': EditSubLobData.lob_id
        };
        this.maintenanceService.checkLOB(payloadNameCheck).subscribe(res => {
          if (res) {
            this.toastrService.error('Sub LOB Name already exists', '', {
              timeOut: 10000,
              positionClass: 'toast-top-center'
            });
            this.lobLoader = false;
          }
          else {
            this.EditSubLobServiceCall(payload);
          }
        });
      }
      else {
        this.EditSubLobServiceCall(payload);
      }
    }
  }

  EditSubLobServiceCall(payload) {
    this.maintenanceService.editSubLOB(payload).subscribe(res => {
      if (res.status === 'Success') {
        this.toastrService.success('Sub LOB Updated Successfully!', '', {
          timeOut: 10000,
          positionClass: 'toast-top-center'
        });
        this.lobLoader = false;
        this.modalEditSubLob.hide();
        this.getLobMappingDetails();
      }
    },
      (error) => {
        console.error(error);
        this.toastrService.error(error.error.message, '', {
          timeOut: 10000,
          positionClass: 'toast-top-center'
        });
      });

  }

  applyEditLob(EditLobData) {
    this.lobLoader = true;
    const payload = {};
    if (EditLobData.LOB_description.isChanged) {
      payload['LOB_description'] = EditLobData.LOB_description.value ? EditLobData.LOB_description.value : null;
    }
    if ((EditLobData.cio_lob.isChanged || EditLobData.LOB_description.isChanged)) {
      payload['lob_id'] = EditLobData.lob_id;
      if (EditLobData.cio_lob.isChanged) {
        payload['cio_lob'] = EditLobData.cio_lob.value;
        const payloadNameCheck = {
          "cio_lob": EditLobData.cio_lob.value
        }
        this.maintenanceService.checkLOB(payloadNameCheck).subscribe(res => {
          if (res) {
            this.toastrService.error('LOB Name already exists', '', {
              timeOut: 10000,
              positionClass: 'toast-top-center'
            });
            this.lobLoader = false;
          }
          else {
            this.EditLobServiceCall(payload);
          }
        });
      }
      else {
        this.EditLobServiceCall(payload);
      }


    }
  }

  EditLobServiceCall(payload) {
    this.maintenanceService.editLLOB(payload).subscribe(res => {
      if (res.status === 'Success') {
        this.toastrService.success('LOB updated Successfully!', '', {
          timeOut: 10000,
          positionClass: 'toast-top-center'
        });
        this.modalEditLob.hide();
        this.lobLoader = false;
        this.getLobMappingDetails();

      }
    },
      (error) => {
        console.error(error);
        this.toastrService.error(error.error.message, '', {
          timeOut: 10000,
          positionClass: 'toast-top-center'
        });
        this.modalEditLob.hide();
        this.lobLoader = false;
      });
  }
  hidepopup(type) {
    if (type === 'add') {
      this.isNewClicked = false;
    }
    else if (type === 'editSubLob') {
      this.isSubLobEditClicked = false;
    }
    else if (type === 'editLob') {
      this.isLobEditClicked = false;
    }
    else if (type === 'bulkEdit') {
      this.isBulkClicked = false;
    }
    else if (type === 'addRemoveCA') {
      this.isAddRemoveClicked = false;
    }
    else {
      this.isDeleteClicked = false;
    }
  }

  hideBulkPopup() {
    this.bulkModel.hide();
    this.isBulkClicked = false;
    this.handleAppicationload();
  }

  hideaddRemovePopup() {
    this.addRemoveCAModel.hide();
    this.isAddRemoveClicked = false;
    this.handleAppicationload();
  }
  showAddRemoveCAPopup() {
    this.isAddRemoveClicked = true;
    this.addRemoveCAModel.show();
  }

  refreshDecomDetailsTable() {
    console.log('refreshDecomDetailsTable called');
    this.getLobMappingDetails();
  }


}
